export const CLOSING_ES = {
  header: {
    title: 'Contratación',
    subtitle:
      'Esta sección resume los <strong>talentos que han aceptado tu oferta</strong>.<br/><br/>Dependiendo de los permisos de tu cuenta, también pueden incluirse los detalles de los costes y la documentación asociada.',
  },
  bingoHeader: {
    label: 'Has contratado a',
    sublabel: '',
  },
  links: {
    resignation_letter: 'La carta de renuncia',
    commitment_letter: 'La carta de compromiso de contratación',
    prospect: 'Ver cálculo',
  },
  tag: {
    text: 'Contratación {{hiring_date}}',
  },
};
